// extracted by mini-css-extract-plugin
export default {"qrContainer":"Qr_qrContainer__ULu52","title":"Qr_title__1ryQS","subtitle":"Qr_subtitle__h2XYR"};